<template>
    <div class="reportList padding-20 bgc box-shadow">
        <div class="topClass" align="right">
            <el-select v-model="typeValue" placeholder="全部类型">
                <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="statusValue" placeholder="全部状态">
                <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-date-picker class="item" v-model="time.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
            <el-input placeholder="请输入媒资名称关键字" v-model="kmcname" style="width: 220px"></el-input>
            <el-input placeholder="请输入评价人关键字" v-model="customername" style="width: 220px"></el-input>
            <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column  label="评价人"  class-name="title" width="180">
                    <template slot-scope="scope">
                        <div class="imageText">
                            <img :src="scope.row.headimageurl?scope.row.headimageurl:require('@/common/images/user.png')">
                            <div>{{ scope.row.customername }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="kmctypetext" label="媒资类型" class-name="center"></el-table-column>
                <el-table-column prop="assetname" label="媒资名称" class-name="center" :show-overflow-tooltip="true" width="300"></el-table-column>
                <el-table-column prop="content" label="评论内容" class-name="center" :show-overflow-tooltip="true" width="300"></el-table-column>
                <el-table-column prop="status" label="状态" class-name="center">
                    <template slot-scope="scope">
                        <div class="imgStatus">
                            <span v-if="scope.row.status === 0" style="color: #E6A23C">待审核</span>
                            <span v-if="scope.row.status === 10" style="color: #67C23A">正常</span>
                            <span v-if="scope.row.status === 11" style="color: #FF4747">已拒绝</span>
                            <span v-if="scope.row.status === 100" style="color: #606266">已删除</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="评价时间" class-name="center" width="160"></el-table-column>
                <el-table-column label="操作" label-class-name="tr" width="130px">
                    <template slot-scope="scope">
                        <div class="tr">
                            <el-button @click="handleDetails(scope.row)" type="text" size="small">详情</el-button><span class="separator" v-if="scope.row.status!==11&& scope.row.status!==100">|</span>
                            <div  v-if="scope.row.status===0">
                                <el-button  @click="handleAdopt(scope.row)" type="text" size="small">通过</el-button>
                                <span class="separator">|</span>
                                <el-button @click="handleRefuse(scope.row)" type="text" size="small">拒绝</el-button>
                                <span class="separator">|</span>
                            </div>
                            <el-button v-if="scope.row.status!==11&& scope.row.status!==100" @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" @getList="searchClick" ref="page"></page>
        </div>
        <!-- start 新建弹窗 -->
        <el-dialog title="评价详情" :visible.sync="dialogFormVisible">
                <div class="details_box">
                    <div class="det_head">
                        <img :src="detailsData.headimageurl" alt="">
                        <span>{{detailsData.customername}}</span>
                    </div>
                    <div class="content_box">
                        <p class="title"><span></span>媒资信息</p>
                        <div class="content_text">
                            <p><b>媒资类型：</b><span>{{detailsData.kmctypetext}}</span></p>
                            <p><b>媒资名称：</b><span>{{detailsData.assetname}}</span></p>
                        </div>
                    </div>
                    <div class="content_box">
                        <p class="title"><span></span>评价信息</p>
                        <div class="content_text">
                            <div class="first_row">
                                <p><b>评价时间：</b><span>{{detailsData.datetime}}</span></p>
                                <p style="padding-left: 130px"><span>IP地址：</span>{{detailsData.ip}}</p>
                            </div>
                            <p><b>评价分数：</b><span>{{detailsData.commentscore}}</span></p>
                            <p><b>评价内容：</b><span>{{detailsData.content}}</span></p>
                        </div>
                    </div>
                </div>
        </el-dialog>
        <!-- end 新建弹窗 -->
    </div>
</template>

<script>
    import {getAllCommentPage,updateCommentStatus} from 'api/curriculumApi'
    import Upload from 'base/upload/upload'
    import {reportMgtCode} from 'api/enumCode'
    import Share from 'base/share/share'
    import Page from 'base/page/page'
    import fecha from 'element-ui/src/utils/date';
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'curriculumComment',
        data() {
            return {
                id:this.$route.query.innerid,
                dialogFormVisible: false,
                form:{}, //表单
                time: {             // 开始/结束时间
                    date: ''
                },
                total: 0,
                tableData: [],
                typeList:[ // 媒资类型列表
                    {
                        label:'全部',
                        value:''
                    },
                    {
                        label:'图文',
                        value:'1'
                    },
                    {
                        label:'报告',
                        value:'2'
                    },
                    {
                        label:'直播',
                        value:'3'
                    },
                    {
                        label:'视频',
                        value:'4'
                    },
                    {
                        label:'专题',
                        value:'5'
                    },
                    {
                        label:'音频',
                        value:'6'
                    },
                    {
                        label:'课程',
                        value:'7'
                    },
                ],
                typeValue:'',
                statusList:[
                    {
                        label:'全部状态',
                        value:''
                    },
                    {
                        label:'待审核',
                        value:'0'
                    },
                    {
                        label:'正常',
                        value:'10'
                    },
                    {
                        label:'已拒绝',
                        value:'11'
                    },
                    {
                        label:'已删除',
                        value:'100'
                    },
                ],
                statusValue:'',
                kmcname:'', //媒资名称
                customername:'', //评价人
                detailsData:{}
            }
        },
        mounted() {
            this._getList()
        },
        methods: {
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            // 获取列表
            _getList() {
                this.setLoading(true);
                getAllCommentPage({
                    data: {
                        courseid:this.id,
                        page: 1,
                        pageSize: 10
                    },
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.tableData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            // 搜索
            searchClick() {
                this.setLoading(true);
                let searchDate = this.time;
                let params = {
                    courseid:this.id,
                    kmctype:this.typeValue,
                    status:this.statusValue,
                    kmcname: this.kmcname,
                    customername: this.customername,
                    begintime: searchDate.date[0]?fecha.format(searchDate.date[0], 'yyyy-MM-dd'):'',
                    endtime: searchDate.date[1]?fecha.format(searchDate.date[1], 'yyyy-MM-dd'):'',
                };
                getAllCommentPage({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.tableData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 打开详情
            handleDetails(row){
                this.dialogFormVisible=true;
                this.detailsData=row
            },
            // 通過
            handleAdopt(row){
                this.setLoading(true);
                let params = {
                    status:10,
                    innerid:row.innerid
                };
                updateCommentStatus({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        console.log(data)
                        this.setLoading(false);
                        this._getList()
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            // 拒绝
            handleRefuse(row){
                this.setLoading(true);
                let params = {
                    status:11,
                    innerid:row.innerid
                };
                updateCommentStatus({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        console.log(data)
                        this.setLoading(false);
                        this._getList()
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            // 删除
            handleDel(row){
                this.setLoading(true);
                let params = {
                    status:100,
                    innerid:row.innerid
                };
                updateCommentStatus({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        console.log(data)
                        this.setLoading(false);
                        this._getList()
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
                'setPage'
            ])
        },
        watch: {},
        computed: {
            ...mapGetters([
                'page',
                'user',
                'permission',
                'shop'
            ])
        },
        components: {
            Page, Share,  Upload
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .reportList{
        .topClass{
            float:right;
            display: flex;
            margin-bottom: 40px;
            .el-input__inner,.el-input,.el-select{
                margin-right: 20px;
                height: 36px;
            }
            .el-button, .el-button--mini{
                height: 36px;
            }
        }
        .result-list{
            .imageText{
                img{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    margin-right: 12px;
                }
            }
        }
    }
    .reportList .center {
        text-align: center;
    }
    /*样式更改 日期选择*/
    .el-range-editor.el-input__inner{
        padding: 0 10px;
        width: 240px;
    }
    .topicIndex .el-date-editor {
        margin-right: 20px;
    }
    /*评价详情*/
    .details_box{
        display: flex;
        flex-direction: column;
        .det_head{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 20px;
            img{
                width: 60px;
                height: 60px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
        .content_box{
            .title{
                margin-bottom: 20px;
                display: flex;
                span{
                    width:2px;
                    height:16px;
                    background:rgba(64,158,255,1);
                    margin-right: 10px;
                    display: inline-block;
                }
            }
            .content_text{
                .first_row{
                    display: flex;
                }
                p,.first_row{
                    line-height: 23px;
                    margin-bottom: 10px;
                    display: flex;
                    color: #333;
                    b{
                        font-weight: normal;
                        width: 80px;
                        color: #666;
                    }
                }
            }
        }
    }
</style>

